import { FetchData } from "services/api";

export const fetchRequestsBetweenDate = (body, signal) =>
  FetchData("/api/request/between-date", {
    method: "POST",
    body: JSON.stringify(body),
    signal,
  });

export const fetchRequestById = (demandeId) =>
  FetchData(`/api/request/${demandeId}`, {
    method: "GET",
  });

export const fetchRequestLogs = (demandeId, signal) =>
  FetchData(`/api/request/log/request/${demandeId}`, {
    method: "GET",
    signal,
  });

export const deleteRequests = (ids, reqUserIdUpdate) =>
  FetchData(`/api/request/delete/${ids}`, {
    method: "PUT",
    body: JSON.stringify({ req_user_id_update: reqUserIdUpdate }),
  });

export const fetchRequestCreationDate = () =>
  FetchData("/api/request/date-creation", {
    method: "GET",
  });

export const fetchClientBranchesByClientId = (clientId) =>
  FetchData(`/api/client/branch/client/${clientId}`, {
    method: "GET",
  });

export const fetchClientContactsByBranchId = (branchId) =>
  FetchData(`/api/client/contact/branch/${branchId}`, {
    method: "GET",
  });

export const assignRequestAgent = (payload) =>
  FetchData("/api/request/assign", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const uploadRequestEmailFile = (idUser, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return FetchData(
    `/api/request/upload/email/${idUser}`,
    {
      method: "PUT",
      body: formData,
    },
    true,
  );
};

export const uploadRequestDocFile = (idUser, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return FetchData(
    `/api/request/upload/doc/${idUser}`,
    {
      method: "PUT",
      body: formData,
    },
    true,
  );
};

export const saveRequest = (demandeId, payload) =>
  demandeId > 0
    ? FetchData(`/api/request/${demandeId}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      })
    : FetchData("/api/request", {
        method: "POST",
        body: JSON.stringify(payload),
      });

export const sendRequestEmail = (payload) =>
  FetchData("/api/request/send-mail", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const saveResponseWithoutEmail = (payload) =>
  FetchData("/api/request/without-send-mail", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const saveRequestResponse = (answerId, payload) =>
  FetchData(`/api/request/response/${answerId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const saveValidatedRequestResponse = (answerId, payload) =>
  FetchData(`/api/request/response/valid-save/${answerId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const createRequestResponse = (payload) =>
  FetchData("/api/request/response", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const upsertRequestResponseDraft = (answerId, payload) =>
  answerId
    ? FetchData(`/api/request/response/save/${answerId}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      })
    : FetchData("/api/request/response/save", {
        method: "POST",
        body: JSON.stringify(payload),
      });

export const createRequestAction = (payload) =>
  FetchData("/api/request/action", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const linkRequestAction = (payload) =>
  FetchData("/api/request/action-link", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateRequestActionLink = (id, payload) =>
  FetchData(`/api/request/action-link/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteRequestActionLink = (id) =>
  FetchData(`/api/request/action-link/${id}`, {
    method: "DELETE",
  });

export const invalidateRequest = (payload) =>
  FetchData("/api/request/invalid", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const validateRequest = (requestId, payload) =>
  FetchData(`/api/request/validate/${requestId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const finishRequest = (payload) =>
  FetchData("/api/request/finish", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const runRequestOrder = (payload) =>
  FetchData("/api/request/run-order", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const createRequestReminder = (payload) =>
  FetchData("/api/request/reminder", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const fetchReadMsgPreview = (filePath) =>
  FetchData("/api/request/read-msg", {
    method: "POST",
    body: JSON.stringify({ file: filePath || "" }),
  });
